<ng-container *ngIf="bannerSlides$ | async as bannerSlides">
  <ngx-glide
    class="banner-slider l-wrapper-push"
    [ngClass]="{'is-single': bannerSlides.length === 1}"
    [showArrows]="false"
    [showBullets]="bannerSlides.length > 1"
    [dragThreshold]="bannerSlides.length !== 1"
    [swipeThreshold]="bannerSlides.length !== 1"
    [gap]="8"
    [autoplay]="bannerSlides.length === 1 ? false : 3500"
    [type]="'carousel'"
    [perView]="1"
  >
    <div class="banner-slider__slide" *ngFor="let slide of bannerSlides; let first = first">
      <div class="banner-slider__img">
        <picture class="cover-picture">
          <source *ngIf="slide.bannerImageUrl['1000x200x100.webp']" [srcset]="slide.bannerImageUrl['1000x200x100.webp']">
          <img
            [src]="slide.bannerImageUrl['src']"
            [alt]="slide.title"
            [title]="slide.title"
            [width]="1000"
            [height]="200"
          >
        </picture>
        <a *ngIf="slide.slug" [routerLink]="['/actions', slide.slug]" class="banner-slider__link"></a>
      </div>
    </div>
  </ngx-glide>
</ng-container>
